import {graphqlRequest} from '@shopify/cli-kit/node/api/graphql';
import {AbortError} from '@shopify/cli-kit/node/error';
import {Logger, outputInfo} from '@shopify/cli-kit/node/output';

import {errorHandler, Header} from '../utils/utils.js';

import type {DeploymentConfig} from './types.js';
import {
  BuildCancelQuery,
  BuildCancelQueryData,
  BuildCancelResponse,
} from './graphql/build-cancel.js';

interface BuildCancelOptions {
  config: DeploymentConfig;
  buildId: string;
  reason: string;
  logger: Logger;
}

export async function buildCancel(
  options: BuildCancelOptions,
): Promise<BuildCancelResponse> {
  const {config, buildId, reason, logger} = options;

  const variables = {
    buildId,
    reason,
  };

  try {
    const response: BuildCancelQueryData = await graphqlRequest({
      query: BuildCancelQuery,
      api: 'Oxygen',
      url: `${config.deploymentUrl}/api/v2/admin/graphql`,
      token: config.deploymentToken.accessToken,
      addedHeaders: {
        [Header.OxygenNamespaceHandle]: config.deploymentToken.namespace,
      },
      variables,
    });

    if (response.buildCancel.userErrors.length >= 1) {
      throw new AbortError(
        `Failed to cancel build: ${response.buildCancel.userErrors[0]?.message}`,
      );
    }
    outputInfo(`Build with id ${buildId} cancelled.`, logger);

    return response.buildCancel;
  } catch (error) {
    errorHandler(error);

    throw error;
  }
}
